import React, { useContext, useEffect, useState } from "react";
import { Heading, Input, SectionHeading } from "../../../components";
import { plus, cross, Plus, CrossSvg } from "../../../components/Icons/Icons";
import { ResumeContext } from "../../../contexts/resumeContext";
import styles from "./SkillsForm.module.css";

const skillsList = [
  "Communication Skills",
  "Customer Service",
  "Microsoft Excel",
  "Microsoft Word",
  "Adobe Photoshop",
  "Linux",
  "Github",
  "Microsoft PowerPoint",
  "HTML",
  "Web Development",
  "Cloud Computing",
  "Data Structure",
  "WordPress",
];

function SkillsForm() {
  const { updateResumeInfo, resumeInfo } = useContext(ResumeContext);

  const [addedSkills, updateAddedSkills] = useState(
    Object.values(resumeInfo?.skills || {}) || []
  );
  const [skillValue, setSkillValue] = useState();

  useEffect(() => {
    updateResumeInfo.current("skills", addedSkills, resumeInfo);
  }, [addedSkills]);

  const addSkill = (skill) => {
    console.log(skill)
    updateAddedSkills((skills) => [...skills, skill.trim()]);
  };

  const removeSkill = (ix) => {
    let addedSkillsTemp = [...addedSkills];
    addedSkillsTemp.splice(ix, 1);
    updateAddedSkills(addedSkillsTemp);
  };

  const handleSkillSubmit = (e) => {
    e.preventDefault();
    if(skillValue && skillValue != ""){
      addSkill(skillValue)
      setSkillValue('')
    }
  }

  return (
    <div>
      <SectionHeading
        editable
        section="SK"
        content="Skills"
        subheading="Choose 5-7 skills to showcase your talents! Make sure they match the keywords of the job description."
      />
      <div className={styles.skillsWrapper}>
        {addedSkills.map((skill, ix) => (
          <button key={skill} onClick={() => removeSkill(ix)} className={styles.skillAdded}>
            {skill} <CrossSvg style={{ color: "#fff", width: 12}} />
          </button>
        ))}
      </div>
      <div className={styles.skillsWrapper}>
        {skillsList.map((skill) =>
          addedSkills.includes(skill) ? null : (
            <button key={skill} onClick={() => addSkill(skill)} className={styles.skill}>
              <img src={plus} /> {skill} 
            </button>
          )
        )}
      </div>
      <form className={styles.skillsForm} onSubmit={handleSkillSubmit}>
        <div>
          <Input
            label="Add skill if not specified"
            value={skillValue}
            onChange={(e) => setSkillValue(e.target.value)}
            placeholder="Press Enter to add"
          />
        </div>
        <button type="submit" className="link" style={{float:'right', marginTop: '1.5em'}}><Plus /> Add</button>
      </form>
    </div>
  );
}

export default SkillsForm;
